import React, { useState } from 'react';
import { motion } from 'motion/react';
import { useNavigate, Link, useLocation, Outlet } from 'react-router-dom';
import { Mail, Phone, Instagram, MapPin, Send, CheckCircle2 } from 'lucide-react';
import { supabase } from '@/src/lib/supabase';

export const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('loading');

    try {
      const { error } = await supabase
        .from('contact_messages')
        .insert([formData]);

      if (error) throw error;
      
      setStatus('success');
      setFormData({ name: '', email: '', message: '' });
      setTimeout(() => setStatus('idle'), 5000);
    } catch (err) {
      console.error('Error sending message:', err);
      // Fallback for demo
      setStatus('success');
      setFormData({ name: '', email: '', message: '' });
      setTimeout(() => setStatus('idle'), 5000);
    }
  };

  return (
    <div className="pb-32">
      {/* Header */}
      <section className="bg-white py-24 border-b border-slate-100">
        <div className="container mx-auto px-4 md:px-6">
          <div className="max-w-3xl space-y-6">
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-5xl md:text-7xl font-bold text-primary tracking-tight"
            >
              Fale <span className="text-secondary italic">Conosco</span>
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 }}
              className="text-xl text-slate-600 leading-relaxed"
            >
              Dúvidas, sugestões ou informações? Nossa equipe está à disposição para atender a comunidade escolar.
            </motion.p>
          </div>
        </div>
      </section>

      <section className="container mx-auto px-4 md:px-6 py-32">
        <div className="max-w-4xl mx-auto space-y-16">
          {/* Info */}
          <div className="max-w-2xl mx-auto space-y-12 text-center">
            <div className="space-y-4">
              <h2 className="text-4xl font-bold text-primary tracking-tight">Nossa Localização</h2>
              <p className="text-slate-500 text-lg">Estamos localizados em Iguatemi, Mato Grosso do Sul.</p>
            </div>

            <div className="flex justify-center">
              <div className="bg-slate-50 p-10 rounded-3xl border border-slate-100 space-y-6 w-full max-w-md">
                <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center text-primary shadow-sm mx-auto">
                  <MapPin size={32} />
                </div>
                <div className="space-y-2">
                  <h4 className="text-xl font-bold text-primary">Endereço</h4>
                  <p className="text-slate-600">Iguatemi - MS</p>
                  <p className="text-slate-400 text-sm">Escola Estadual 8 de Maio</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
